import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSalesforcemin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: .2,
		d: "m11.3 9.478-.061-.006-.033.053-.135.22c-.34.55-.926.877-1.571.877-.225 0-.446-.04-.655-.12l-.324-.123-.078-.03-.043.071-.18.296a2.384 2.384 0 0 1-2.053 1.156 2.404 2.404 0 0 1-1.972-1.03l-.13-.19-.032-.044-.055.002-.23.01a1.847 1.847 0 0 1-1.926-1.842c0-.585.283-1.142.755-1.488l.24-.177.058-.042-.021-.068-.09-.285a2.401 2.401 0 0 1 4.051-2.35l.073-.068-.073.068.263.284.063.068.073-.058.302-.242-.062-.078.062.078c.33-.264.728-.403 1.15-.403.591 0 1.132.272 1.484.748l.08-.06-.08.06.201.272.048.065.074-.034.307-.14a2.403 2.403 0 0 1 3.397 2.184 2.403 2.403 0 0 1-2.62 2.389l-.257-.023Zm.478-5.8a3.44 3.44 0 0 0-1.06.166 2.892 2.892 0 0 0-2.051-.86c-.498 0-.989.13-1.42.374a3.445 3.445 0 0 0-2.191-.791 3.437 3.437 0 0 0-3.365 4.12 2.89 2.89 0 0 0-.902 2.09 2.881 2.881 0 0 0 2.725 2.875 3.437 3.437 0 0 0 4.362.798c.384-.22.723-.515.996-.864a2.858 2.858 0 0 0 2.9-1.042h.006a3.437 3.437 0 0 0 3.433-3.433 3.437 3.437 0 0 0-3.433-3.433Z"
	})
});
const ForwardRef = forwardRef(SvgSalesforcemin);
export { ForwardRef as ReactComponent };
